import { Box, Typography } from "@mui/material";

const DEFAULT_WIDTH = 100;
const DEFAULT_HEIGHT = 40;

export const LandmarkItem = ({
  label,
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
}: {
  label: string;
  width?: number;
  height?: number;
}) => (
  <Box
    sx={{
      width,
      height,
      bgcolor: "grey.300",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 1,
      border: "2px dashed",
      borderColor: "grey.500",
    }}
  >
    <Typography
      variant="caption"
      sx={{ color: "grey.800", fontWeight: "bold" }}
    >
      {label}
    </Typography>
  </Box>
);
